import React, { useState } from 'react';
import {
  Tabs,
  Tab,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import COLORS from '../constants/colors';
import { array } from 'prop-types';
import { useLocation } from '@reach/router';
import { useIntl } from 'gatsby-plugin-intl';
import { FormattedMessage } from 'gatsby-plugin-intl';
import SwipeableViews from 'react-swipeable-views';
import FONTS from '../constants/fonts';

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 'fit-content',
    '& > div': {
      width: 40,
      borderBottom: `5px solid ${COLORS.GREEN}`,
    },
  },
  root: { fontWeight: 700 },
})(props => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <div /> }}
  />
));

const useStyles = makeStyles(theme => ({
  content: {
    width: '100%',
  },
  Subnav: {
    color: '#141414',
    fontWeight: FONTS.WEIGHT.BOLD,
    maxWidth: '100%',
    marginTop: 4,
    marginBottom: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: 10,
      marginBottom: 10,
    },
    '&>.MuiTabs-scrollButtons.Mui-disabled': {
      display: 'none',
    },
    '& .MuiTouchRipple-root': {
      color: COLORS.BLUE,
      zIndex: -1,
    },
    '& .MuiTab-root.Mui-selected': {
      fontWeight: FONTS.WEIGHT.BOLD,
    },
    '& .MuiTab-root': {
      fontWeight: FONTS.WEIGHT.BOLD,
      textTransform: 'lowercase',
      fontSize: FONTS.SIZE.XS,
      opacity: 1,
    },
  },
  divider: {
    borderTop: '1px solid #ccc',
    opacity: 0.5,
    width: '100%',
  },
}));

const getShownPageIndex = (currentPath, subNavItems) => {
  for (
    let index = subNavItems.length - 1;
    index >= 0;
    index--
  ) {
    if (currentPath.includes(subNavItems[index].link)) {
      return index;
    }
  }
  return false;
};

const Subpages = ({ navItems, contents }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const location = useLocation();
  const [selectedPage, setSelectedPage] = useState(
    getShownPageIndex(location.pathname, navItems)
  );

  const handleChange = index => {
    setSelectedPage(index);
    window.history.pushState(
      null,
      null,
      navItems[index].link
    );
    document.title = formatMessage({
      id: navItems[index].intlId,
    });
  };

  return selectedPage !== false ? (
    <>
      <StyledTabs
        value={selectedPage}
        className={classes.Subnav}
        onChange={(e, i) => handleChange(i)}
        variant="scrollable"
        scrollButtons="on"
      >
        {navItems.map(item => (
          <Tab
            key={item.intlId}
            label={<FormattedMessage id={item.intlId} />}
            className={classes.tab}
          />
        ))}
      </StyledTabs>
      <div className={classes.divider} />
      <SwipeableViews
        className={classes.content}
        axis="x"
        index={selectedPage}
        onChangeIndex={handleChange}
      >
        {contents.map((Content, i) =>
          i === selectedPage ? (
            <Content key={navItems[i].link} />
          ) : (
            <div key={navItems[i].link} />
          )
        )}
      </SwipeableViews>
    </>
  ) : (
    <></>
  );
};

Subpages.propTypes = {
  navItems: array,
  contents: array,
};

export default Subpages;
